import { z } from 'zod';

import { PaginationSchema } from '../../../pagination.js';

export const EnableProductAtPlaceBodySchema = z.object({
  tenantProductId: z.uuid(),
  validFrom: z.iso.date().optional(),
});

export const EnableProductAtPlaceResponseSchema = z.object({
  placeProductId: z.uuid(),
});

export const DisableProductAtPlaceBodySchema = z
  .object({
    validUntil: z.iso.date().optional(),
  })
  .default({});

export const ListPlaceProductsQuerySchema = PaginationSchema;

export const PlaceProductListItemSchema = z.object({
  id: z.uuid(),
  tenantProductId: z.uuid(),
  productName: z.string(),
  productSku: z.string().nullable(),
  validFrom: z.iso.date(),
  validUntil: z.iso.date().nullable(),
  effectiveToday: z.boolean(),
});

export const ListPlaceProductsResponseSchema = z.object({
  items: z.array(PlaceProductListItemSchema),
  pagination: z.object({
    cursor: z.string().nullable(),
    hasMore: z.boolean(),
  }),
});

export const ProductPlaceValidityItemSchema = z.object({
  placeId: z.uuid(),
  placeName: z.string(),
  placeProductId: z.uuid().nullable(),
  validFrom: z.iso.date().nullable(),
  validUntil: z.iso.date().nullable(),
  effectiveToday: z.boolean(),
});

export const ListProductPlaceValidityResponseSchema = z.object({
  items: z.array(ProductPlaceValidityItemSchema),
});

export type EnableProductAtPlaceBody = z.infer<typeof EnableProductAtPlaceBodySchema>;
export type EnableProductAtPlaceResponse = z.infer<typeof EnableProductAtPlaceResponseSchema>;
export type DisableProductAtPlaceBody = z.infer<typeof DisableProductAtPlaceBodySchema>;
export type ListPlaceProductsQuery = z.infer<typeof ListPlaceProductsQuerySchema>;
export type ListPlaceProductsResponse = z.infer<typeof ListPlaceProductsResponseSchema>;
export type ProductPlaceValidityItem = z.infer<typeof ProductPlaceValidityItemSchema>;
export type ListProductPlaceValidityResponse = z.infer<
  typeof ListProductPlaceValidityResponseSchema
>;
